import { useMutation } from '@apollo/client';

import { CreateVoucherInput } from '../../apollo/__generated__/graphql';
import { CREATE_VOUCHER } from '../graphql/mutations/createVoucherMutation.graphql';
import { VOUCHERS } from '../graphql/query/vouchersQuery.graphql';

export const useCreateVoucherMutation = (onCompleted: () => void) => {
  const [mutate] = useMutation(CREATE_VOUCHER, { onCompleted });

  const createVoucher = (createVoucherInput: CreateVoucherInput) => {
    mutate({
      variables: {
        createVoucherInput,
      },
      refetchQueries: [VOUCHERS],
    });
  };

  return { createVoucher };
};
